import { makeRequest } from "./api";

export const FetchDashboardStats = async () => {
  return makeRequest("/api/admin/dashboard/stats");
};
